import { heroThread } from "@/mocks/gossip";

export default function Hero() {
  return (
    <section id="today" className="relative -mt-16 flex min-h-[720px] w-full items-end md:-mt-[72px] md:min-h-[780px]">
      <img
        src="https://readdy.ai/api/search-image?query=wide%20cinematic%20editorial%20hero%20background%20of%20a%20dramatic%20backstage%20concert%20stage%20with%20silhouettes%20rushing%20under%20hot%20red%20and%20amber%20spotlights%2C%20crowd%20reaction%20energy%2C%20warm%20crimson%20atmosphere%2C%20high%20detail%20magazine%20cover%20mood%2C%20no%20recognizable%20face&width=1600&height=900&seq=gossip-hero-main&orientation=landscape"
        alt="吃瓜吧持续吃瓜封面图"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-foreground-950/25"></div>
      <div className="absolute inset-x-0 top-24 mx-auto max-w-[1240px] px-4 md:top-28 md:px-6">
        <div className="flex flex-wrap items-center gap-2">
          <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
            <i className="ri-flashlight-fill text-xs"></i>{heroThread.badge}
          </span>
          <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-white/15 px-3 py-1 text-xs text-white backdrop-blur">
            <i className="ri-timer-flash-line text-xs"></i>{heroThread.category}
          </span>
        </div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-[1240px] px-4 pb-14 md:px-6 md:pb-20">
        <h1 className="max-w-4xl font-heading text-3xl font-black leading-tight text-white md:text-5xl md:leading-tight">
          {heroThread.title}
        </h1>
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-white/80 md:text-base">{heroThread.summary}</p>

        <div className="mt-6 flex flex-wrap items-center gap-2">
          {heroThread.metaChips.map((c) => (
            <span key={c.label} className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-white/12 px-3 py-1.5 text-xs text-white backdrop-blur">
              <i className={"text-accent-300 " + c.icon}></i>{c.label}
            </span>
          ))}
        </div>

        <div className="mt-7 max-w-sm">
          <div className="flex items-center justify-between text-[11px] text-white/70">
            <span>今晚进展跟进进度</span>
            <span className="text-accent-300">正在推进 · 新进展随时顶上来</span>
          </div>
          <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-white/20">
            <div className="h-full rounded-full bg-accent-400" style={{ width: `${heroThread.progress}%` }}></div>
          </div>
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-3">
          <a
            href="#floor"
            className="inline-flex items-center whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600"
          >
            <i className="ri-stack-line mr-1.5 text-sm"></i>进入蹲帖
          </a>
          <a
            href="#feed"
            className="inline-flex items-center whitespace-nowrap rounded-md bg-white/15 px-5 py-2.5 text-sm font-medium text-white backdrop-blur hover:bg-white/25"
          >
            <i className="ri-arrow-up-line mr-1.5 text-sm"></i>跟进最新进展
          </a>
        </div>
      </div>
    </section>
  );
}